/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Code16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M3.558 12.162a.876.876 0 01-.63-.265L.263 9.156A.927.927 0 010 8.507c0-.244.095-.477.263-.649l2.665-2.741a.875.875 0 011.261.018.936.936 0 01-.018 1.298L2.146 8.507l2.025 2.074a.927.927 0 01.263.649.927.927 0 01-.263.649.878.878 0 01-.613.283zm8.884 0a.876.876 0 00.63-.265l2.665-2.741A.927.927 0 0016 8.507a.927.927 0 00-.263-.649l-2.665-2.741a.874.874 0 00-1.261 0 .936.936 0 000 1.297l2.016 2.093-2.016 2.074a.927.927 0 00-.263.649c0 .244.095.477.263.649.165.178.392.28.63.283zM6.668 13.99a.648.648 0 01-.231 0 1.011 1.011 0 01-.622-1.225L8.48 3.792a.918.918 0 01.376-.63.868.868 0 01.707-.138c.49.174.764.712.622 1.225L7.52 13.222a.897.897 0 01-.852.768z"
        />
    </AccessibleSVG>
);

export default Code16;
